//export const NODE_APP_BASE_URL = 'https://qa2.empyra.com/msnow';
//export const REACT_APP_BASE_URL = 'https://qa2.empyra.com';
 
// export const NODE_APP_BASE_URL = process.env.NODE_APP_BASE_URL;
// export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
 
export const APP_SECRET = "ENCODINGSECRET"
 
export const NODE_APP_BASE_URL = "https://snowprod.empyra.com/msnow"
export const REACT_APP_BASE_URL = "https://snowprod.empyra.com"
